var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"iconFont",staticStyle:{"outline-style":"none"},attrs:{"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg"},on:{"click":_vm.handleClick}},[_c('use',{attrs:{"xlink:href":_vm.iconName,"xmlns:xlink":"http://www.w3.org/1999/xlink"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }